import * as p from '@clack/prompts'
import type { EnvPromptOptions } from '@cli-types/next-adapter/runtime.js'
import { readNonEmptyEnvVar } from '@cli-utils/files.js'

export async function resolvePasswordEnvValue(options: EnvPromptOptions): Promise<string> {
  const existingValue = readNonEmptyEnvVar(options.cwd, options.key)
  if (existingValue) {
    return existingValue
  }

  const result = await p.password({
    message: options.message,
    validate: options.validate
  })

  if (p.isCancel(result)) {
    throw new Error(options.cancelMessage)
  }

  options.overwriteEnvKeys.add(options.key)
  return result.trim()
}
